var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.054,
    height: 19.929,
    viewBox: "0 0 20.054 19.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting",
    transform: "translate(-0.05 -0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(5.957 6.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M23.036,27.072a4.136,4.136,0,1,1,4.136-4.136A4.132,4.132,0,0,1,23.036,27.072Zm0-6.674a2.569,2.569,0,1,0,2.569,2.569A2.581,2.581,0,0,0,23.036,20.4Z",
    transform: "translate(-18.9 -18.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(5.957 6.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M23.036,27.072a4.136,4.136,0,1,1,4.136-4.136A4.132,4.132,0,0,1,23.036,27.072Zm0-6.674a2.569,2.569,0,1,0,2.569,2.569A2.581,2.581,0,0,0,23.036,20.4Z",
    transform: "translate(-18.9 -18.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(5.957 6.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M23.036,27.072a4.136,4.136,0,1,1,4.136-4.136A4.132,4.132,0,0,1,23.036,27.072Zm0-6.674a2.569,2.569,0,1,0,2.569,2.569A2.581,2.581,0,0,0,23.036,20.4Z",
    transform: "translate(-18.9 -18.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0.05 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M11.754,20.129H8.4A1.638,1.638,0,0,1,6.772,18.5V17.09c0-.031,0-.031-.031-.031a5.266,5.266,0,0,1-1.253-.877,1.738,1.738,0,0,0-.251-.188l-1.974,1.1a1.032,1.032,0,0,1-1.253-.407L.129,13.455A1,1,0,0,1,.536,12.2l1.88-1.034c-.031-.345-.063-.689-.063-1.034a10.28,10.28,0,0,1,.063-1.065L.6,8.065a.883.883,0,0,1-.47-.627,1.146,1.146,0,0,1,.094-.783l1.817-3.1a1.051,1.051,0,0,1,1.5-.313l1.723.971c.063-.063.157-.125.219-.188A6.349,6.349,0,0,1,6.74,3.146a.031.031,0,0,0,.031-.031V1.829A1.638,1.638,0,0,1,8.4.2h3.353a1.638,1.638,0,0,1,1.629,1.629V3.051c0,.031,0,.031.031.031a6.01,6.01,0,0,1,1.222.846c.094.063.157.157.251.219l1.974-1.1a1.032,1.032,0,0,1,1.253.407l1.911,3.228a1,1,0,0,1-.407,1.253L17.77,8.974a6.084,6.084,0,0,1,.063,1.1,6.12,6.12,0,0,1-.094,1.065l1.817,1a.894.894,0,0,1,.47.6,1.041,1.041,0,0,1-.094.752L18.084,16.62a1.064,1.064,0,0,1-1.5.282l-1.723-.971a1.57,1.57,0,0,0-.251.219A4.979,4.979,0,0,1,13.383,17a.031.031,0,0,0-.031.031v1.441A1.619,1.619,0,0,1,11.754,20.129ZM5.3,14.395a1.353,1.353,0,0,1,.815.282,4.688,4.688,0,0,1,.407.345,4.142,4.142,0,0,0,.909.658,1.628,1.628,0,0,1,.94,1.473v1.41a.067.067,0,0,0,.063.063h3.353a.067.067,0,0,0,.063-.063v-1.5a1.555,1.555,0,0,1,.909-1.441,3.809,3.809,0,0,0,.877-.627,4.688,4.688,0,0,1,.407-.345,1.278,1.278,0,0,1,1.441-.125l1.535.877,1.253-2.131-1.441-.783a1.37,1.37,0,0,1-.689-1.41,5.1,5.1,0,0,0,.094-.971,8.934,8.934,0,0,0-.063-.971,1.349,1.349,0,0,1,.658-1.41L18.3,6.906,17.018,4.775l-1.535.877a1.278,1.278,0,0,1-1.441-.125,5.456,5.456,0,0,1-.439-.376,3.809,3.809,0,0,0-.877-.627,1.623,1.623,0,0,1-.909-1.441V1.8a.067.067,0,0,0-.063-.063H8.4a.067.067,0,0,0-.063.063V3.083A1.608,1.608,0,0,1,7.43,4.524a5.041,5.041,0,0,0-.909.658,4.606,4.606,0,0,1-.407.313,1.278,1.278,0,0,1-1.441.125L3.137,4.775,1.883,6.906l1.473.815a1.3,1.3,0,0,1,.658,1.41,4.439,4.439,0,0,0-.063.94,9.49,9.49,0,0,0,.063.971h0a1.331,1.331,0,0,1-.658,1.347l-1.5.846,1.285,2.131,1.535-.877A2.02,2.02,0,0,1,5.3,14.395Zm-2.851-3.1Z",
    transform: "translate(-0.05 -0.2)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/SettingIcon.6ca9926e1c8662f56e74aa7c94f48cb5.svg";
export { ForwardRef as ReactComponent };